import React from 'react';
import { Grid } from 'semantic-ui-react';
import CartItemDescription from './components/CartItemDescription';
import CartItemEditButton from './components/CartItemEditButton';
import CartItemQuantityButton from './components/CartItemQuantityButton';
import { getItemName, getItemPhoto } from '../../../../../modules/ordering/services/order-item';
import { CartItemPropType } from '../../CartSummary.propTypes';
import './CartItemSummary.css';
var defaultProps = {
  readOnly: false,
  loading: false,
  getOrderItemOptions: null
};
function CartItemSummary(_ref) {
  var item = _ref.item,
    _onUpdateQuantity = _ref.onUpdateQuantity,
    onUpdate = _ref.onUpdate,
    onDelete = _ref.onDelete,
    loading = _ref.loading,
    readOnly = _ref.readOnly,
    getOrderItemOptions = _ref.getOrderItemOptions;
  var itemDescription = item.item_data.description,
    itemInstructions = item.instructions,
    modifiers = item.item_variation_data.modifiers,
    price = item.price,
    quantity = item.quantity;
  var photo = getItemPhoto(item);
  var name = getItemName(item, {
    includeQuantity: readOnly
  });
  var itemModifiers = (modifiers || []).map(function (modifier) {
    return modifier.name;
  }).join(', ');
  return /*#__PURE__*/React.createElement(Grid, {
    className: "cart-item-summary-grid"
  }, /*#__PURE__*/React.createElement(CartItemDescription, {
    name: name,
    photo: photo,
    itemDescription: itemDescription,
    itemInstructions: itemInstructions,
    itemModifiers: itemModifiers,
    price: price
  }), !readOnly && /*#__PURE__*/React.createElement(Grid.Row, {
    className: "cart-item-buttons-row"
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    width: 2
  }), /*#__PURE__*/React.createElement(Grid.Column, {
    width: 14,
    className: "cart-item-buttons-column"
  }, getOrderItemOptions ? /*#__PURE__*/React.createElement(CartItemEditButton, {
    item: item,
    onUpdate: onUpdate,
    loading: loading,
    getOrderItemOptions: getOrderItemOptions
  }) : /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(CartItemQuantityButton, {
    quantity: quantity,
    onDelete: onDelete,
    onUpdateQuantity: function onUpdateQuantity(type) {
      return _onUpdateQuantity(type);
    },
    loading: loading
  }))));
}
CartItemSummary.defaultProps = defaultProps;
export default CartItemSummary;